import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';

export function formatPriceCell(value: number | null | undefined) {
  if (typeof value === 'number') {
    return defaultCurrencyFormat(value);
  }
  return '';
}
